"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var LinearScale_1 = require("./LinearScale");
var _2013_1_1 = new Date(2013, 0, 1, 12, 0, 0).getTime();
var CoContributionBasis = (function () {
    function CoContributionBasis() {
        this._maximumCoContribution = null;
        this._memberContributionTest = null;
        this._incomeTest = null;
        this._includeCoContributions = true;
    }
    CoContributionBasis.prototype.initialise = function (p, indexationBasis) {
        this._maximumCoContribution = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._memberContributionTest = new LinearScale_1.LinearScale();
        this._incomeTest = new LinearScale_1.LinearScale();
        this._maximumCoContribution.initialise(p.getParamNumber("CurrentMaximumCoContribution"), indexationBasis);
        this._memberContributionTest.initialise(0, p.getParamNumber("MaximumContributionBase"), indexationBasis);
        this._incomeTest.initialise(p.getParamNumber("CoContributionLowerThreshold"), p.getParamNumber("CoContributionUpperThreshold"), indexationBasis);
        this._includeCoContributions = p.getParamBoolean("IncludeCoContributions");
    };
    CoContributionBasis.prototype.annualUpdate = function (projectionRunAsAt, yearCount) {
        var startThisProjectionYear;
        startThisProjectionYear = projectionRunAsAt.plus(yearCount - 1);
        if (startThisProjectionYear.after(_2013_1_1)) {
            this._maximumCoContribution.index(yearCount);
            this._memberContributionTest.index(yearCount);
            this._incomeTest.index(yearCount);
        }
    };
    CoContributionBasis.prototype.calculateCoContributions = function (salaryToTest, postTaxContributions) {
        if (this._includeCoContributions) {
            var incomeTestProportion;
            var memberContributionTestProportion;
            incomeTestProportion = this._incomeTest.getProportion(salaryToTest);
            memberContributionTestProportion = this._memberContributionTest.getProportion(postTaxContributions);
            memberContributionTestProportion = 1 - memberContributionTestProportion;
            return this._maximumCoContribution.value * incomeTestProportion * memberContributionTestProportion;
        }
        else {
            return 0;
        }
    };
    CoContributionBasis.prototype.getMaximumCoContribution = function () {
        return this._maximumCoContribution.value;
    };
    CoContributionBasis.prototype.getLowerIncomeThreshold = function () {
        return this._incomeTest.minimumThreshold;
    };
    CoContributionBasis.prototype.getUpperIncomeThreshold = function () {
        return this._incomeTest.maximumThreshold;
    };
    CoContributionBasis.prototype.getLowerContributionThreshold = function () {
        return this._memberContributionTest.minimumThreshold;
    };
    CoContributionBasis.prototype.getUpperContributionThreshold = function () {
        return this._memberContributionTest.maximumThreshold;
    };
    return CoContributionBasis;
}());
exports.CoContributionBasis = CoContributionBasis;
//# sourceMappingURL=CoContributionBasis.js.map